import CompetitionPage from "../../common/components/CompetitionPage";
import { REWARD_OFFERING } from "../../constants";

interface WgtBehaviourMainProps {
  readonly offerId: REWARD_OFFERING;
}

function WgtBehaviourMain({ offerId }: WgtBehaviourMainProps) {
  return (
    <CompetitionPage
      offerId={offerId}
      loadingMessage="Activating your West Gate Tunnel offer"
      alreadyEnteredText="Already Activated"
    />
  );
}

export default WgtBehaviourMain;